import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import { IonButton, IonButtons, IonContent, IonDatetime, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonLoading, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonSelect, IonSelectOption, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { mesaGerarCupom, urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import '../../../../../components/HistoricoAtendimentos/HistoricoAtendimentos.css';
import HistoricoAtendimentosLista from '../../../../../components/HistoricoAtendimentos/HistoricoAtendimentosLista';

const TotemHistorico: React.FC = () => {
    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [mostartAlerta] = useIonAlert();
    const [arrayPedidos, setArrayPedidos] = useState<any>([]);
    const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
    const [pedidopk, setPedidopk] = useState("");
    const [pedidosk, setPedidosk] = useState("");
    const [pedidogsi2sk, setPedidogsi2sk] = useState("");
    const [pesquisaData, setPesquisaData] = useState<any>("Pesquisar");
    const [showLoadingPage, setShowLoadingPage] = useState(true);
    const [showModalData, setShowModalData] = useState(false);
    const popover = useRef<HTMLIonPopoverElement>(null);
    const contentRef = useRef<HTMLIonContentElement | null>(null);
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const [filtroPesquisa, setFiltroPesquisa] = useState<any>("");

    useEffect(() => {
        carregarHistorico("");
        setPesquisaData('Pesquisar');
    }, []);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
    });

    function doRefresh(event: any) {
        carregarHistorico(filtroPesquisa);
        setTimeout(() => {
            event.detail.complete();
        }, 1200);
    }

    async function gerarCupom(pedidoid: any) {
        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof tkn === "string") { token = tkn; }

        try {
            setShowLoadingPage(true);
            const resp = await fetch(mesaGerarCupom.url.replaceAll("{id}", pedidoid.replaceAll(/#/g, "%23")), {
                method: mesaGerarCupom.method,
                headers: [["token", token]],
                credentials: 'include'
            });
            const result = await resp.json();
            if (result) {
                console.log("result", result);

                mostartAlerta({
                    backdropDismiss: false,
                    header: 'Gerar Cupom',
                    message: '<strong>Cupom</strong> foi gerado com sucesso.',
                    buttons: [
                        {
                            text: 'Cancelar',
                            role: 'cancel',
                        },
                        {
                            text: 'Visualizar',
                            cssClass: 'primary',
                            handler: () => {
                                window.open(result, '_blank');
                            }
                        }
                    ],
                    onDidDismiss: (e) => console.log('did dismiss'),
                });
            }
        } catch (error) {
            console.error("Erro ao gerar cupom:", error);
            setTextToast("Ocorreu um erro ao gerar o cupom.");
            setShowToast(true);
        } finally {
            setShowLoadingPage(false);
        }
    }

    async function carregarHistorico(data: any) {
        let token: string = "";
        const tkn = localStorage.getItem("token");
        if (typeof tkn === "string") { token = tkn; }

        let valor = data || "";
        if (valor) {
            valor = valor.replaceAll(/#/g, "%23");
        }

        try {
            const resp: Response = await fetch(
                urlBaseCore.url + "/ordens/historico?campo=data" +
                "&valor=" + valor +
                "&filtro=totem" +
                "&lojas=" + Buffer.from(loja).toString('base64'),
                {
                    method: urlBaseCore.method,
                    headers: [["token", token]],
                    credentials: 'include'
                }
            );
            const res = await resp.json();

            if (resp.status === 400 || resp.status === 401) {
                setShowLoadingPage(false);
                history.replace("/login/");
                return;
            }

            if (res && res.LastEvaluatedKey) {
                setPedidopk(res.LastEvaluatedKey.pk);
                setPedidosk(res.LastEvaluatedKey.sk);
                setPedidogsi2sk(res.LastEvaluatedKey.gsi2sk);
                setDesabilitarInfiniteScroll(false);
            } else {
                setDesabilitarInfiniteScroll(true);
            }

            setArrayPedidos(res.Items || []);
        } catch (err) {
            console.error("Erro ao carregar histórico totem:", err);
        } finally {
            setShowLoadingPage(false);
        }
    }

    async function carregarMaisPedidos($event: CustomEvent<void>) {
        await carregarMaisPedidosChamada();
        ($event.target as HTMLIonInfiniteScrollElement).complete();
    }

    async function carregarMaisPedidosChamada() {
        let token: string = "";
        const tkn = localStorage.getItem("token");
        if (typeof tkn === "string") { token = tkn; }

        let valor = filtroPesquisa || "";
        if (valor) {
            valor = valor.replaceAll(/#/g, "%23");
        }

        try {
            const res: Response = await fetch(
                urlBaseCore.url + "/ordens/historico?campo=data" +
                "&filtro=totem" +
                "&valor=" + valor +
                "&isk=" + pedidogsi2sk +
                "&pk=" + pedidopk +
                "&sk=" + pedidosk +
                "&lojas=" + Buffer.from(loja).toString('base64'),
                {
                    method: urlBaseCore.method,
                    headers: [["token", token]],
                    credentials: 'include'
                }
            );
            const pedidos = await res.json();

            if (res.status === 400 || res.status === 401) {
                history.replace("/login/");
                return;
            }

            if (pedidos.Items) {
                setArrayPedidos((prev: any) => [...prev, ...pedidos.Items]);

                if (pedidos.LastEvaluatedKey) {
                    setPedidopk(pedidos.LastEvaluatedKey.pk);
                    setPedidosk(pedidos.LastEvaluatedKey.sk);
                    setPedidogsi2sk(pedidos.LastEvaluatedKey.gsi2sk);
                    setDesabilitarInfiniteScroll(false);
                } else {
                    setPedidopk("");
                    setPedidosk("");
                    setPedidogsi2sk("");
                    setDesabilitarInfiniteScroll(true);
                }
            }
        } catch (err) {
            console.error("Erro ao carregar mais pedidos:", err);
        }
    }

    const openPopover = (e: any) => {
        popover.current!.event = e;
        setShowModalData(true);
    };

    return (
        <IonPage className="historico-atendimentos-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="historico-atendimentos-toolbar">
                    <IonButtons slot="start">
                        <IonButton aria-label="Voltar" onClick={() => {
                            history.goBack();
                        }}>
                            <IonIcon slot="icon-only" icon={arrowBack} />
                        </IonButton>
                    </IonButtons>

                    <IonTitle>Histórico Totem</IonTitle>

                </IonToolbar>
            </IonHeader>

            <IonContent className="historico-atendimentos-content" scrollEvents={true} ref={contentRef}>
                <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <main className="historico-atendimentos-container">
                    <HistoricoAtendimentosLista
                        filtros={
                            <div className="historico-atendimentos-filters">
                                <IonSelect interface="popover" className="historico-filter-select" aria-label="Filtrar por" name="Filtros" title="Filtros" value="data" multiple={false} cancelText="Cancelar" okText="Ok">
                                    <IonSelectOption value="data">Data</IonSelectOption>
                                </IonSelect>
                                <IonButton className="historico-filter-search" fill="outline" aria-label="Pesquisar data" onClick={e => { openPopover(e); }}>
                                    <IonLabel>{pesquisaData}</IonLabel>
                                </IonButton>
                            </div>
                        }
                        itens={arrayPedidos || []}
                        carregando={showLoadingPage}
                        esconderValores={false}
                        nomePadrao="Cliente Totem"
                        renderAtendimento={(value: any) => <>
                            <strong>{value.clienteNome || 'Cliente Totem'}</strong>
                            {value.tipoRetirada && <span className="historico-lista-secondary">Retirada: {value.tipoRetirada}</span>}
                            {value.formaPagamento && <span className="historico-lista-secondary">
                                Pagamento: {Array.isArray(value.formaPagamento)
                                    ? value.formaPagamento.map((f: any) => f.pagamento || f.tipo).join(', ')
                                    : value.formaPagamento}
                            </span>}
                        </>}
                        onCupom={value => { gerarCupom(value.pk); }}
                    />

                    <IonInfiniteScroll
                        threshold="100px"
                        onIonInfinite={(e: CustomEvent<void>) => carregarMaisPedidos(e)}
                        position="bottom"
                        disabled={desabilitarInfiniteScroll}>
                        <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais pedidos..."></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </main>

                <IonToast
                    isOpen={showToast}
                    position="middle"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />

                <IonLoading
                    isOpen={showLoadingPage}
                    onDidDismiss={() => { setShowLoadingPage(false); }}
                    spinner='circles'
                />
            </IonContent>

            <IonPopover ref={popover}
                isOpen={showModalData}
                onDidDismiss={() => setShowModalData(false)}>
                <IonDatetime
                    presentation='date'
                    onIonChange={e => {
                        if (e.detail.value) {
                            let data = e.detail.value.toString().substring(0, 10);
                            const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(Date.parse(data));
                            setPesquisaData(dataFormatada);
                            setFiltroPesquisa(data);
                            carregarHistorico(data);
                        }
                    }}
                />
            </IonPopover>
        </IonPage>
    );
};

export default TotemHistorico;
